// @generated by protobuf-ts 2.9.0 with parameter generate_dependencies,force_optimize_code_size,long_type_string,ts_nocheck
// @generated from protobuf file "app/build/v1/build.proto" (package "viam.app.build.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { CreatePackageRequest } from "../../packages/v1/packages";
/**
 * @generated from protobuf message viam.app.build.v1.StartBuildRequest
 */
export interface StartBuildRequest {
    /**
     * repo to build
     *
     * @generated from protobuf field: string repo = 1;
     */
    repo: string;
    /**
     * optional git ref; defaults to 'main'
     *
     * @generated from protobuf field: optional string ref = 2;
     */
    ref?: string;
    /**
     * list of platforms to build
     *
     * @generated from protobuf field: repeated string platforms = 3;
     */
    platforms: string[];
    /**
     * module_id as prefix:name pair
     *
     * @generated from protobuf field: string module_id = 4;
     */
    moduleId: string;
    /**
     * version of the module to publish
     * must be valid semver2.0 string (ex: 1.2.3-rc0)
     *
     * @generated from protobuf field: string module_version = 5;
     */
    moduleVersion: string;
    /**
     * checkout token. provide this for private repos
     *
     * @generated from protobuf field: optional string token = 6;
     */
    token?: string;
    /**
     * optional working directory. defaults to repo root.
     *
     * @generated from protobuf field: optional string workdir = 7;
     */
    workdir?: string;
    /**
     * optional distro for linux platforms.
     * must be bookworm for cpp module builds.
     *
     * @generated from protobuf field: optional string distro = 8;
     */
    distro?: string;
    /**
     * optional target builder. defaults to 'default'.
     * use 'viam-cloudbuild-test' to target the new Viam build service (org must be whitelisted).
     *
     * @generated from protobuf field: optional string builder = 9;
     */
    builder?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.StartBuildResponse
 */
export interface StartBuildResponse {
    /**
     * @generated from protobuf field: string build_id = 1;
     */
    buildId: string;
    /**
     * present when the requested builder was unavailable for this org and the default builder was used instead.
     *
     * @generated from protobuf field: optional string builder_fallback_message = 2;
     */
    builderFallbackMessage?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.GetLogsRequest
 */
export interface GetLogsRequest {
    /**
     * @generated from protobuf field: string build_id = 1;
     */
    buildId: string;
    /**
     * @generated from protobuf field: string platform = 2;
     */
    platform: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.ReloadBuildInfo
 */
export interface ReloadBuildInfo {
    /**
     * platform to build the reload module for
     *
     * @generated from protobuf field: string platform = 1;
     */
    platform: string;
    /**
     * optional working directory. defaults to repo root
     *
     * @generated from protobuf field: optional string workdir = 2;
     */
    workdir?: string;
    /**
     * org ID for the module
     *
     * @generated from protobuf field: string module_id = 3;
     */
    moduleId: string;
    /**
     * optional distro for linux platforms.
     * must be bookworm for cpp module builds.
     *
     * @generated from protobuf field: optional string distro = 4;
     */
    distro?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.StartReloadBuildRequest
 */
export interface StartReloadBuildRequest {
    /**
     * @generated from protobuf oneof: cloud_build
     */
    cloudBuild: {
        oneofKind: "package";
        /**
         * @generated from protobuf field: viam.app.packages.v1.CreatePackageRequest package = 1;
         */
        package: CreatePackageRequest;
    } | {
        oneofKind: "buildInfo";
        /**
         * @generated from protobuf field: viam.app.build.v1.ReloadBuildInfo build_info = 2;
         */
        buildInfo: ReloadBuildInfo;
    } | {
        oneofKind: undefined;
    };
    /**
     * optional target builder. defaults to 'default'.
     * use 'viam-cloudbuild-test' to target the new Viam build service (org must be whitelisted).
     *
     * @generated from protobuf field: optional string builder = 3;
     */
    builder?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.StartReloadBuildResponse
 */
export interface StartReloadBuildResponse {
    /**
     * @generated from protobuf field: string build_id = 1;
     */
    buildId: string;
    /**
     * present when the requested builder was unavailable for this org and the default builder was used instead.
     *
     * @generated from protobuf field: optional string builder_fallback_message = 2;
     */
    builderFallbackMessage?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.SourceUploadBuildInfo
 */
export interface SourceUploadBuildInfo {
    /**
     * platforms to build the module for
     *
     * @generated from protobuf field: repeated string platforms = 1;
     */
    platforms: string[];
    /**
     * optional working directory. defaults to repo root.
     *
     * @generated from protobuf field: optional string workdir = 2;
     */
    workdir?: string;
    /**
     * org id/namespace and module name
     *
     * @generated from protobuf field: string module_id = 3;
     */
    moduleId: string;
    /**
     * optional distro for linux platforms.
     * must be bookworm for cpp module builds.
     *
     * @generated from protobuf field: optional string distro = 4;
     */
    distro?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.StartSourceUploadBuildRequest
 */
export interface StartSourceUploadBuildRequest {
    /**
     * @generated from protobuf oneof: cloud_build
     */
    cloudBuild: {
        oneofKind: "package";
        /**
         * @generated from protobuf field: viam.app.packages.v1.CreatePackageRequest package = 1;
         */
        package: CreatePackageRequest;
    } | {
        oneofKind: "buildInfo";
        /**
         * @generated from protobuf field: viam.app.build.v1.SourceUploadBuildInfo build_info = 2;
         */
        buildInfo: SourceUploadBuildInfo;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string module_version = 3;
     */
    moduleVersion: string;
    /**
     * optional target builder. defaults to 'default'.
     * use 'viam-cloudbuild-test' to target the new Viam build service (org must be whitelisted).
     *
     * @generated from protobuf field: optional string builder = 4;
     */
    builder?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.StartSourceUploadBuildResponse
 */
export interface StartSourceUploadBuildResponse {
    /**
     * @generated from protobuf field: string build_id = 1;
     */
    buildId: string;
    /**
     * present when the requested builder was unavailable for this org and the default builder was used instead.
     *
     * @generated from protobuf field: optional string builder_fallback_message = 2;
     */
    builderFallbackMessage?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.StartPackageBuildRequest
 */
export interface StartPackageBuildRequest {
    /**
     * module_id to build for
     *
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * the version of source code to build for
     *
     * @generated from protobuf field: string package_version = 2;
     */
    packageVersion: string;
    /**
     * version of the module to publish to the registry. must be valid semver2.0 string (ex: 1.2.3-rc0)
     *
     * @generated from protobuf field: string module_version = 3;
     */
    moduleVersion: string;
    /**
     * specify the platforms to build for (ex: linux/arm64)
     *
     * @generated from protobuf field: repeated string platforms = 4;
     */
    platforms: string[];
    /**
     * optional distro for linux platforms.
     * must be bookworm for cpp module builds.
     *
     * @generated from protobuf field: optional string distro = 5;
     */
    distro?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.StartPackageBuildResponse
 */
export interface StartPackageBuildResponse {
    /**
     * @generated from protobuf field: string build_id = 1;
     */
    buildId: string;
}
/**
 * GetLogsResponse is a streaming endpoint that may have multiple messages that belong
 * to the same build_step if there are too many bytes to fit into a single gRPC
 * response.
 *
 * @generated from protobuf message viam.app.build.v1.GetLogsResponse
 */
export interface GetLogsResponse {
    /**
     * @generated from protobuf field: string build_step = 1;
     */
    buildStep: string;
    /**
     * includes multiple lines delimited by \n\r
     *
     * @generated from protobuf field: string data = 2;
     */
    data: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.JobInfo
 */
export interface JobInfo {
    /**
     * @generated from protobuf field: string build_id = 1;
     */
    buildId: string;
    /**
     * @generated from protobuf field: string platform = 2;
     */
    platform: string;
    /**
     * @generated from protobuf field: string version = 3;
     */
    version: string;
    /**
     * @generated from protobuf field: viam.app.build.v1.JobStatus status = 4;
     */
    status: JobStatus;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp start_time = 5;
     */
    startTime?: Timestamp;
    /**
     * @generated from protobuf field: optional google.protobuf.Timestamp end_time = 6;
     */
    endTime?: Timestamp;
    /**
     * @generated from protobuf field: optional string build_step = 7;
     */
    buildStep?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.ListJobsRequest
 */
export interface ListJobsRequest {
    /**
     * module_id as prefix:name pair
     *
     * @generated from protobuf field: string module_id = 1;
     */
    moduleId: string;
    /**
     * don't return more than max_jobs_length jobs
     * if not present, return all jobs.
     *
     * @generated from protobuf field: optional int32 max_jobs_length = 2;
     */
    maxJobsLength?: number;
    /**
     * only return jobs that match this build id
     * if not present, return all jobs.
     *
     * @generated from protobuf field: optional string build_id = 3;
     */
    buildId?: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.ListJobsResponse
 */
export interface ListJobsResponse {
    /**
     * jobs is ordered by (build start time, alphabetical platform).
     *
     * @generated from protobuf field: repeated viam.app.build.v1.JobInfo jobs = 1;
     */
    jobs: JobInfo[];
}
/**
 * @generated from protobuf message viam.app.build.v1.RepoLink
 */
export interface RepoLink {
    /**
     * viam internal ID which maps to an external oauth app
     *
     * @generated from protobuf field: string oauth_app_link_id = 1;
     */
    oauthAppLinkId: string;
    /**
     * OrgID of the module
     *
     * @generated from protobuf field: string org_id = 2;
     */
    orgId: string;
    /**
     * Public namespace of the module. This is for user display in ListRepoLinksResponse.
     * It is ignored in LinkRepoRequest.
     *
     * @generated from protobuf field: optional string namespace = 3;
     */
    namespace?: string;
    /**
     * name of the module (just the name, not the dotted org:name form)
     *
     * @generated from protobuf field: string module_name = 4;
     */
    moduleName: string;
    /**
     * git repo in owner/repository form
     *
     * @generated from protobuf field: string repo = 5;
     */
    repo: string;
    /**
     * email of the viam user who created this
     *
     * @generated from protobuf field: string viam_user = 6;
     */
    viamUser: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.LinkRepoRequest
 */
export interface LinkRepoRequest {
    /**
     * @generated from protobuf field: viam.app.build.v1.RepoLink link = 1;
     */
    link?: RepoLink;
}
/**
 * @generated from protobuf message viam.app.build.v1.LinkRepoResponse
 */
export interface LinkRepoResponse {
    /**
     * @generated from protobuf field: string repo_link_id = 1;
     */
    repoLinkId: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.UnlinkRepoRequest
 */
export interface UnlinkRepoRequest {
    /**
     * @generated from protobuf field: string repo_link_id = 1;
     */
    repoLinkId: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.UnlinkRepoResponse
 */
export interface UnlinkRepoResponse {
}
/**
 * @generated from protobuf message viam.app.build.v1.ListRepoLinksRequest
 */
export interface ListRepoLinksRequest {
}
/**
 * @generated from protobuf message viam.app.build.v1.ListRepoLinksResponse
 */
export interface ListRepoLinksResponse {
    /**
     * @generated from protobuf field: repeated viam.app.build.v1.RepoLink links = 1;
     */
    links: RepoLink[];
}
/**
 * @generated from protobuf message viam.app.build.v1.ListAppLinksRequest
 */
export interface ListAppLinksRequest {
}
/**
 * represents a link between viam users / orgs and an external oauth app
 *
 * @generated from protobuf message viam.app.build.v1.AppLink
 */
export interface AppLink {
    /**
     * viam internal ID which maps to an external oauth app
     *
     * @generated from protobuf field: string oauth_app_link_id = 1;
     */
    oauthAppLinkId: string;
    /**
     * email of the viam user that owns this
     *
     * @generated from protobuf field: string viam_user = 2;
     */
    viamUser: string;
    /**
     * username of the external user who created this
     *
     * @generated from protobuf field: string external_user = 3;
     */
    externalUser: string;
    /**
     * list of org public namespace (where available) or org UUIDs attached to the external app
     *
     * @generated from protobuf field: repeated string org_id_or_ns = 4;
     */
    orgIdOrNs: string[];
}
/**
 * @generated from protobuf message viam.app.build.v1.ListAppLinksResponse
 */
export interface ListAppLinksResponse {
    /**
     * @generated from protobuf field: repeated viam.app.build.v1.AppLink links = 1;
     */
    links: AppLink[];
}
/**
 * @generated from protobuf message viam.app.build.v1.RemoveAppLinkRequest
 */
export interface RemoveAppLinkRequest {
    /**
     * viam internal ID which maps to an external oauth app
     *
     * @generated from protobuf field: string oauth_app_link_id = 1;
     */
    oauthAppLinkId: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.RemoveAppLinkResponse
 */
export interface RemoveAppLinkResponse {
}
/**
 * @generated from protobuf message viam.app.build.v1.LinkOrgRequest
 */
export interface LinkOrgRequest {
    /**
     * viam internal ID which maps to an external oauth app
     *
     * @generated from protobuf field: string oauth_app_link_id = 1;
     */
    oauthAppLinkId: string;
    /**
     * @generated from protobuf field: string org_id = 2;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.LinkOrgResponse
 */
export interface LinkOrgResponse {
}
/**
 * @generated from protobuf message viam.app.build.v1.UnlinkOrgRequest
 */
export interface UnlinkOrgRequest {
    /**
     * viam internal ID which maps to an external oauth app
     *
     * @generated from protobuf field: string oauth_app_link_id = 1;
     */
    oauthAppLinkId: string;
    /**
     * @generated from protobuf field: string org_id = 2;
     */
    orgId: string;
}
/**
 * @generated from protobuf message viam.app.build.v1.UnlinkOrgResponse
 */
export interface UnlinkOrgResponse {
}
/**
 * @generated from protobuf enum viam.app.build.v1.JobStatus
 */
export enum JobStatus {
    /**
     * @generated from protobuf enum value: JOB_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * IN_PROGRESS = pending or executing on cloud infra. Artifact has not been uploaded.
     *
     * @generated from protobuf enum value: JOB_STATUS_IN_PROGRESS = 1;
     */
    IN_PROGRESS = 1,
    /**
     * @generated from protobuf enum value: JOB_STATUS_FAILED = 2;
     */
    FAILED = 2,
    /**
     * @generated from protobuf enum value: JOB_STATUS_DONE = 3;
     */
    DONE = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class StartBuildRequest$Type extends MessageType<StartBuildRequest> {
    constructor() {
        super("viam.app.build.v1.StartBuildRequest", [
            { no: 1, name: "repo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "ref", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "platforms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "module_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "token", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "workdir", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "distro", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "builder", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartBuildRequest
 */
export const StartBuildRequest = new StartBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartBuildResponse$Type extends MessageType<StartBuildResponse> {
    constructor() {
        super("viam.app.build.v1.StartBuildResponse", [
            { no: 1, name: "build_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "builder_fallback_message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartBuildResponse
 */
export const StartBuildResponse = new StartBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLogsRequest$Type extends MessageType<GetLogsRequest> {
    constructor() {
        super("viam.app.build.v1.GetLogsRequest", [
            { no: 1, name: "build_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.GetLogsRequest
 */
export const GetLogsRequest = new GetLogsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReloadBuildInfo$Type extends MessageType<ReloadBuildInfo> {
    constructor() {
        super("viam.app.build.v1.ReloadBuildInfo", [
            { no: 1, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "workdir", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "distro", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.ReloadBuildInfo
 */
export const ReloadBuildInfo = new ReloadBuildInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartReloadBuildRequest$Type extends MessageType<StartReloadBuildRequest> {
    constructor() {
        super("viam.app.build.v1.StartReloadBuildRequest", [
            { no: 1, name: "package", kind: "message", oneof: "cloudBuild", T: () => CreatePackageRequest },
            { no: 2, name: "build_info", kind: "message", oneof: "cloudBuild", T: () => ReloadBuildInfo },
            { no: 3, name: "builder", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartReloadBuildRequest
 */
export const StartReloadBuildRequest = new StartReloadBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartReloadBuildResponse$Type extends MessageType<StartReloadBuildResponse> {
    constructor() {
        super("viam.app.build.v1.StartReloadBuildResponse", [
            { no: 1, name: "build_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "builder_fallback_message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartReloadBuildResponse
 */
export const StartReloadBuildResponse = new StartReloadBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SourceUploadBuildInfo$Type extends MessageType<SourceUploadBuildInfo> {
    constructor() {
        super("viam.app.build.v1.SourceUploadBuildInfo", [
            { no: 1, name: "platforms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "workdir", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "distro", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.SourceUploadBuildInfo
 */
export const SourceUploadBuildInfo = new SourceUploadBuildInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartSourceUploadBuildRequest$Type extends MessageType<StartSourceUploadBuildRequest> {
    constructor() {
        super("viam.app.build.v1.StartSourceUploadBuildRequest", [
            { no: 1, name: "package", kind: "message", oneof: "cloudBuild", T: () => CreatePackageRequest },
            { no: 2, name: "build_info", kind: "message", oneof: "cloudBuild", T: () => SourceUploadBuildInfo },
            { no: 3, name: "module_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "builder", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartSourceUploadBuildRequest
 */
export const StartSourceUploadBuildRequest = new StartSourceUploadBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartSourceUploadBuildResponse$Type extends MessageType<StartSourceUploadBuildResponse> {
    constructor() {
        super("viam.app.build.v1.StartSourceUploadBuildResponse", [
            { no: 1, name: "build_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "builder_fallback_message", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartSourceUploadBuildResponse
 */
export const StartSourceUploadBuildResponse = new StartSourceUploadBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartPackageBuildRequest$Type extends MessageType<StartPackageBuildRequest> {
    constructor() {
        super("viam.app.build.v1.StartPackageBuildRequest", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "package_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "module_version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "platforms", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "distro", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartPackageBuildRequest
 */
export const StartPackageBuildRequest = new StartPackageBuildRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class StartPackageBuildResponse$Type extends MessageType<StartPackageBuildResponse> {
    constructor() {
        super("viam.app.build.v1.StartPackageBuildResponse", [
            { no: 1, name: "build_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.StartPackageBuildResponse
 */
export const StartPackageBuildResponse = new StartPackageBuildResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetLogsResponse$Type extends MessageType<GetLogsResponse> {
    constructor() {
        super("viam.app.build.v1.GetLogsResponse", [
            { no: 1, name: "build_step", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "data", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.GetLogsResponse
 */
export const GetLogsResponse = new GetLogsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobInfo$Type extends MessageType<JobInfo> {
    constructor() {
        super("viam.app.build.v1.JobInfo", [
            { no: 1, name: "build_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "platform", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "version", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "status", kind: "enum", T: () => ["viam.app.build.v1.JobStatus", JobStatus, "JOB_STATUS_"] },
            { no: 5, name: "start_time", kind: "message", T: () => Timestamp },
            { no: 6, name: "end_time", kind: "message", T: () => Timestamp },
            { no: 7, name: "build_step", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.JobInfo
 */
export const JobInfo = new JobInfo$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListJobsRequest$Type extends MessageType<ListJobsRequest> {
    constructor() {
        super("viam.app.build.v1.ListJobsRequest", [
            { no: 1, name: "module_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "max_jobs_length", kind: "scalar", opt: true, T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "build_id", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.ListJobsRequest
 */
export const ListJobsRequest = new ListJobsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListJobsResponse$Type extends MessageType<ListJobsResponse> {
    constructor() {
        super("viam.app.build.v1.ListJobsResponse", [
            { no: 1, name: "jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobInfo }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.ListJobsResponse
 */
export const ListJobsResponse = new ListJobsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RepoLink$Type extends MessageType<RepoLink> {
    constructor() {
        super("viam.app.build.v1.RepoLink", [
            { no: 1, name: "oauth_app_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "namespace", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "module_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "repo", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "viam_user", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.RepoLink
 */
export const RepoLink = new RepoLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LinkRepoRequest$Type extends MessageType<LinkRepoRequest> {
    constructor() {
        super("viam.app.build.v1.LinkRepoRequest", [
            { no: 1, name: "link", kind: "message", T: () => RepoLink }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.LinkRepoRequest
 */
export const LinkRepoRequest = new LinkRepoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LinkRepoResponse$Type extends MessageType<LinkRepoResponse> {
    constructor() {
        super("viam.app.build.v1.LinkRepoResponse", [
            { no: 1, name: "repo_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.LinkRepoResponse
 */
export const LinkRepoResponse = new LinkRepoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlinkRepoRequest$Type extends MessageType<UnlinkRepoRequest> {
    constructor() {
        super("viam.app.build.v1.UnlinkRepoRequest", [
            { no: 1, name: "repo_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.UnlinkRepoRequest
 */
export const UnlinkRepoRequest = new UnlinkRepoRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlinkRepoResponse$Type extends MessageType<UnlinkRepoResponse> {
    constructor() {
        super("viam.app.build.v1.UnlinkRepoResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.UnlinkRepoResponse
 */
export const UnlinkRepoResponse = new UnlinkRepoResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRepoLinksRequest$Type extends MessageType<ListRepoLinksRequest> {
    constructor() {
        super("viam.app.build.v1.ListRepoLinksRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.ListRepoLinksRequest
 */
export const ListRepoLinksRequest = new ListRepoLinksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListRepoLinksResponse$Type extends MessageType<ListRepoLinksResponse> {
    constructor() {
        super("viam.app.build.v1.ListRepoLinksResponse", [
            { no: 1, name: "links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => RepoLink }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.ListRepoLinksResponse
 */
export const ListRepoLinksResponse = new ListRepoLinksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppLinksRequest$Type extends MessageType<ListAppLinksRequest> {
    constructor() {
        super("viam.app.build.v1.ListAppLinksRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.ListAppLinksRequest
 */
export const ListAppLinksRequest = new ListAppLinksRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppLink$Type extends MessageType<AppLink> {
    constructor() {
        super("viam.app.build.v1.AppLink", [
            { no: 1, name: "oauth_app_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "viam_user", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "external_user", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "org_id_or_ns", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.AppLink
 */
export const AppLink = new AppLink$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppLinksResponse$Type extends MessageType<ListAppLinksResponse> {
    constructor() {
        super("viam.app.build.v1.ListAppLinksResponse", [
            { no: 1, name: "links", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppLink }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.ListAppLinksResponse
 */
export const ListAppLinksResponse = new ListAppLinksResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppLinkRequest$Type extends MessageType<RemoveAppLinkRequest> {
    constructor() {
        super("viam.app.build.v1.RemoveAppLinkRequest", [
            { no: 1, name: "oauth_app_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.RemoveAppLinkRequest
 */
export const RemoveAppLinkRequest = new RemoveAppLinkRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAppLinkResponse$Type extends MessageType<RemoveAppLinkResponse> {
    constructor() {
        super("viam.app.build.v1.RemoveAppLinkResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.RemoveAppLinkResponse
 */
export const RemoveAppLinkResponse = new RemoveAppLinkResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LinkOrgRequest$Type extends MessageType<LinkOrgRequest> {
    constructor() {
        super("viam.app.build.v1.LinkOrgRequest", [
            { no: 1, name: "oauth_app_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.LinkOrgRequest
 */
export const LinkOrgRequest = new LinkOrgRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class LinkOrgResponse$Type extends MessageType<LinkOrgResponse> {
    constructor() {
        super("viam.app.build.v1.LinkOrgResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.LinkOrgResponse
 */
export const LinkOrgResponse = new LinkOrgResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlinkOrgRequest$Type extends MessageType<UnlinkOrgRequest> {
    constructor() {
        super("viam.app.build.v1.UnlinkOrgRequest", [
            { no: 1, name: "oauth_app_link_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "org_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.UnlinkOrgRequest
 */
export const UnlinkOrgRequest = new UnlinkOrgRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UnlinkOrgResponse$Type extends MessageType<UnlinkOrgResponse> {
    constructor() {
        super("viam.app.build.v1.UnlinkOrgResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message viam.app.build.v1.UnlinkOrgResponse
 */
export const UnlinkOrgResponse = new UnlinkOrgResponse$Type();
/**
 * @generated ServiceType for protobuf service viam.app.build.v1.BuildService
 */
export const BuildService = new ServiceType("viam.app.build.v1.BuildService", [
    { name: "StartBuild", options: {}, I: StartBuildRequest, O: StartBuildResponse },
    { name: "GetLogs", serverStreaming: true, options: {}, I: GetLogsRequest, O: GetLogsResponse },
    { name: "ListJobs", options: {}, I: ListJobsRequest, O: ListJobsResponse },
    { name: "LinkRepo", options: {}, I: LinkRepoRequest, O: LinkRepoResponse },
    { name: "UnlinkRepo", options: {}, I: UnlinkRepoRequest, O: UnlinkRepoResponse },
    { name: "ListRepoLinks", options: {}, I: ListRepoLinksRequest, O: ListRepoLinksResponse },
    { name: "ListAppLinks", options: {}, I: ListAppLinksRequest, O: ListAppLinksResponse },
    { name: "RemoveAppLink", options: {}, I: RemoveAppLinkRequest, O: RemoveAppLinkResponse },
    { name: "LinkOrg", options: {}, I: LinkOrgRequest, O: LinkOrgResponse },
    { name: "UnlinkOrg", options: {}, I: UnlinkOrgRequest, O: UnlinkOrgResponse },
    { name: "StartReloadBuild", clientStreaming: true, options: {}, I: StartReloadBuildRequest, O: StartReloadBuildResponse },
    { name: "StartSourceUploadBuild", clientStreaming: true, options: {}, I: StartSourceUploadBuildRequest, O: StartSourceUploadBuildResponse },
    { name: "StartPackageBuild", options: {}, I: StartPackageBuildRequest, O: StartPackageBuildResponse }
]);
